import { useQuery } from "@tanstack/react-query";
import { buscarSaude, type Saude } from "./api";

export const CHAVE_SAUDE = ["saude"] as const;

/** Intervalos oferecidos na tela para reconsultar a saúde; `0` desliga a atualização. */
export const INTERVALOS_DE_ATUALIZACAO = [0, 15_000, 60_000] as const;
export type IntervaloDeAtualizacao = (typeof INTERVALOS_DE_ATUALIZACAO)[number];

/**
 * Estado da API e do banco. Uma única consulta por página: o react-query deduplica as
 * chamadas, então a topbar e o painel de saúde compartilham a mesma resposta.
 */
export function useSaude(intervalo: IntervaloDeAtualizacao = 0) {
  return useQuery<Saude>({
    queryKey: CHAVE_SAUDE,
    queryFn: ({ signal }) => buscarSaude({ signal }),
    refetchInterval: intervalo === 0 ? false : intervalo,
    staleTime: 5_000,
    retry: 1,
  });
}
